const DEFAULT_SERVER_PREFIX = "http://localhost:6200";

const SERVER_PREFIX = process.env["NODE_ENV"] == 'development' ? DEFAULT_SERVER_PREFIX : "";
const API_PREFIX = process.env["NODE_ENV"] == 'development' ? DEFAULT_SERVER_PREFIX + "/api" : "/api";

export {
    API_PREFIX,SERVER_PREFIX
}